import React, { createContext, useContext, useState } from 'react'
import { getWordOfDayIndex } from '../lib/words'

interface GameContextType {
    wordIndex: number
    setWordIndex: (index: number) => void
}

const GameContext = createContext<GameContextType | undefined>(undefined)

export function GameProvider({ children }: { children: React.ReactNode }) {
    // Get initial word index from URL or default to today's word
    const urlParams = new URLSearchParams(window.location.search)
    const initialIndex = urlParams.get('word') ? Number(urlParams.get('word')) : getWordOfDayIndex()

    const [wordIndex, setWordIndex] = useState(initialIndex)

    return <GameContext.Provider value={{ wordIndex, setWordIndex }}>{children}</GameContext.Provider>
}

export function useGame() {
    const context = useContext(GameContext)
    if (context === undefined) {
        throw new Error('useGame must be used within a GameProvider')
    }
    return context
}
